import React, { useEffect, useState } from 'react'
import { CircularProgress, Grid, makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import { useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import HealthDetailsIcon from 'src/assets/RiskReport_images/healthDetails.svg'
import { RISK_REPORTS } from 'src/utils/constants/RiskReports'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import Modal from 'src/components/common/Modal'
import DetailedView from 'src/components/RiskReports/PremuimAndClaims/DetailedView'
import NavigateBackButton from 'src/components/common/NavigateBackButton'
import CloseButton from 'src/components/common/CloseButton'
import DownloadReports from 'src/components/RiskCategories/components/DownloadReports'
import CallToAction from 'src/components/RiskCategories/components/CallToAction'
import ClaimConsumption from 'src/components/RiskReports/ClaimConsumption/ClaimConsumption'
import ClaimTrend from 'src/components/RiskReports/ClaimTrend/ClaimTrend'
import { FETCH_RISK_REPORT } from 'src/services/riskCategoriesService'
import UpcomingHealthRenewals from 'src/components/RiskReports/UpComingRenewals/UpcomingHealthRenewals'
import ValueAddedServices from 'src/components/RiskReports/ValueAddedServices/ValueAddedServices'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { Aggregate } from 'src/components/RiskReports/Aggregate/Aggregate'
import { INSURANCE_DETAILS } from 'src/utils/constants/InsuranceDetails'
import { INSURANCE_NAMES } from 'src/utils/constants/InsuranceNames'
import { isCorporateCeo, isCorporatePOC } from 'src/utils/commonMethods'
import {
  CALL_TO_ACTION_TEXT,
  DOWNLOAD_REPORTS_TEXT,
  DOWNLOAD_REPORTS_TITLE,
  portFolioColumns,
} from 'src/utils/constants/RiskCategory'
import { INSURANCE_CATEGORIES } from 'src/utils/constants/common'
import PendingClaims from 'src/components/RiskReports/PendingClaims/PendingClaims'

const HealthInsuranceDetails = ({
  title,
  handleCloseDetails,
  handleTotalCloseDetails,
  insuranceName,
  subInsuranceType,
}) => {
  const classes = useStyles()
  const userInfo = useSelector((state) => state?.userInfo)
  const [healthInsuranceDetails, setHealthInsuranceDetails] = useState({})
  const [modalOpen, setModalClose] = useState(false)

  let clientId = userInfo?.userInfo?.userData?.clientId

  const { loading, error, data } = useQuery(FETCH_RISK_REPORT(), {
    variables: {
      clientId: clientId ?? userInfo?.userName,
      insuranceType: insuranceName,
      subInsuranceType: subInsuranceType ?? null,
    },
    errorPolicy: 'all',
    // fetchPolicy: "cache-and-network",
  })

  useEffect(() => {
    if (data) {
      setHealthInsuranceDetails(data?.getRiskReport)
    }
  }, [data])

  if (loading)
    return (
      <div className={classes.circularProgressPosition}>
        <CircularProgress />
      </div>
    )
  if (error)
    return (
      <div>
        <GraphQlErrors error={error} />
      </div>
    )

  const claimStatusCounts = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.claimStatusCounts',
    []
  )
  const financialClaimStatusCounts = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.financialYearClaimStatusCounts',
    []
  )
  const claimsTypeData = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.claimsTypeData',
    []
  )
  const financialClaimsTypeData = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.financialYearClaimsData',
    []
  )
  const claimConsumptionCounts = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.claimConsumptionCounts',
    []
  )
  const portFolioData = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.healthPortfolioAnalysis',
    []
  )
  const claimStatusUpdatedOn = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.claimStatusUpdatedOn',
    null
  )
  const financialClaimStatusUpdatedOn = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.financialYearClaimStatusUpdatedOn',
    null
  )
  const groupHealthKeyDetails = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.groupHealthKeyDetails',
    []
  )

  const downloadReportData = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.groupedReports',
    {}
  )

  const policies = get(healthInsuranceDetails, 'riskInsurance.policies', [])
  const aggregatedPolicies = get(
    healthInsuranceDetails,
    'riskInsurance.aggregatedPolicies',
    []
  )
  const reportUrls = get(
    healthInsuranceDetails,
    'riskInsurance.riskData.reportUrls',
    []
  )
  const aggregates = get(
    healthInsuranceDetails,
    'policyInsuranceTypeAggregate',
    []
  )
  const handleReportsDownload = () => {
    if (reportUrls?.length === 0) return
    for (const url of reportUrls) {
      window.open(url, '_blank')
    }
  }
  const handleDetailedView = () => {
    setModalClose(true)
  }

  const CloseModal = () => {
    setModalClose(false)
  }

  const singleRow = (item) => {
    return (
      <div className={classes.rowContianer}>
        <p className={classes.sumInsuredTableText1}>{item?.year}</p>
        <p className={classes.sumInsuredTableText1}>
          {item?.numberOfEmployees}
        </p>
        <p className={classes.sumInsuredTableText1}>{item?.numberOfLives}</p>
        <p
          className={classes.sumInsuredTableText1}
        >{`${item?.parentsIncluded}`}</p>
        <p className={classes.sumInsuredTableText1}>{item?.premiumPaid}</p>
        <p className={classes.sumInsuredTableText1}>{item?.claimSettled}</p>
        <p className={classes.sumInsuredTableText1}>
          {item?.claimsOutstanding}
        </p>
        <p className={classes.sumInsuredTableText1}>
          {item?.claimsRatio === null ? '-' : item?.claimsRatio}
        </p>
        <br />
      </div>
    )
  }

  const showPendingClaimsDetailedView = () => {
    return (
      isCorporatePOC(userInfo?.userInfo?.userData?.roles) ||
      isCorporateCeo(userInfo?.userInfo?.userData?.roles)
    )
  }
  return (
    <div className='healthInsuranceParent'>
      <div className={classes.root}>
        {modalOpen ? (
          <Modal
            bgcolor={'#FFF'}
            ordered={modalOpen}
            width={'60%'}
            left={'20%'}
            top={'14%'}
            modelClosed={CloseModal}
          >
            <DetailedView
              closefunction={CloseModal}
              data={portFolioData}
              // selectedYear={selectedYear}
              totalData={portFolioData}
              type={INSURANCE_CATEGORIES?.HEALTH}
            />
          </Modal>
        ) : null}
        <div className={classes.backBtn}>
          <NavigateBackButton
            tooltipTitle='Back'
            title='Health Portfolio Analysis'
            handleClick={handleCloseDetails}
          />
        </div>
        <CloseButton
          title='Close'
          handleClose={handleTotalCloseDetails}
          classname={classes.clsBtn}
        />
        <h2 className={classes.riskTitle}>{title}</h2>
        <div className={classes.contentDetails}>
          <Grid container spacing={2} alignItems='stretch'>
            <Grid item xs={12} sm={6} md={3}>
              <div className={classes.cardRoot}>
                <DownloadReports
                  title={DOWNLOAD_REPORTS_TITLE}
                  text={DOWNLOAD_REPORTS_TEXT}
                  Icon={HealthDetailsIcon}
                  handleClick={handleReportsDownload}
                  downloadReportData={downloadReportData}
                />
              </div>
              <div className={`${classes.cardRoot} ${classes.cardPadding}`}>
                <UpcomingHealthRenewals
                  data={policies}
                  aggregatedPolicies={aggregatedPolicies}
                  ClientId={clientId}
                  insuranceName={INSURANCE_NAMES?.GROUP_HEALTH_INSURANCE}
                />
              </div>
              <div className={classes.cardRoot}>
                <Aggregate
                  premium={aggregates?.[0]?.premium ?? 0}
                  sumAssured={aggregates?.[0]?.sumAssured ?? 0}
                  vehicleIdv={aggregates?.[0]?.vehicleIdv ?? 0}
                  insuranceType={insuranceName}
                />
              </div>
              <div className={classes.cardRoot}>
                <ValueAddedServices data={policies} />
              </div>

              <div className={classes.cardRoot}>
                <CallToAction
                  text={CALL_TO_ACTION_TEXT}
                  options={[INSURANCE_DETAILS?.HELP_MOBILE]}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <div className={classes.cardRoot1}>
                <div className={classes.sumInsuredContainer}>
                  <p className={classes.sumInsuredTableColumnText}>
                    Sum Insured Range :{' '}
                    <span className={classes.sumInsuredTableValue}>
                      {groupHealthKeyDetails
                        ? groupHealthKeyDetails?.sumInsuredRange
                        : '-'}
                    </span>
                  </p>
                  <p className={classes.premiumPaidTableColumnText}>
                    Premium Paid :{' '}
                    <span className={classes.sumInsuredTableValue}>
                      {groupHealthKeyDetails
                        ? formatToINR(groupHealthKeyDetails?.premiumPaid)
                        : '0'}
                    </span>
                  </p>
                </div>
                <div className={classes.permanentEmployeesContainer}>
                  <p className={classes.sumInsuredTableText}>
                    No. of Permanent Employees <br />
                    <span className={classes.sumInsuredTableValue}>
                      {groupHealthKeyDetails
                        ? groupHealthKeyDetails?.permanentEmployees
                        : '0'}
                    </span>
                  </p>
                  <p className={classes.sumInsuredTableText}>
                    No. of Contract Employees
                    <br />
                    <span className={classes.sumInsuredTableValue}>
                      {groupHealthKeyDetails
                        ? groupHealthKeyDetails?.contactEmployees
                        : '0'}
                    </span>
                  </p>
                  <p className={classes.sumInsuredTableText}>
                    Total No. of Employees <br />
                    <span className={classes.sumInsuredTableValue}>
                      {groupHealthKeyDetails
                        ? groupHealthKeyDetails?.totalEmployees
                        : '0'}
                    </span>
                  </p>
                  <p className={classes.sumInsuredTableText}>
                    No. of Employees covered <br />
                    <span className={classes.sumInsuredTableValue}>
                      {groupHealthKeyDetails
                        ? groupHealthKeyDetails?.employeesCovered
                        : '0'}
                    </span>
                  </p>
                  <p className={classes.sumInsuredTableText}>
                    No. of Lives covered
                    <br />
                    <span className={classes.sumInsuredTableValue}>
                      {groupHealthKeyDetails
                        ? groupHealthKeyDetails?.numberOfLives
                        : '0'}
                    </span>
                  </p>
                  <p className={classes.sumInsuredTableText}>
                    Avg. family size <br />
                    <span className={classes.sumInsuredTableValue}>
                      {groupHealthKeyDetails
                        ? groupHealthKeyDetails?.avgFamilySize
                        : '0'}
                    </span>
                  </p>
                  <p className={classes.sumInsuredTableText}>
                    Definition of Family <br />
                    <p className={classes.familyTableValue}>
                      {groupHealthKeyDetails
                        ? groupHealthKeyDetails?.familyDefinition
                        : '0'}
                    </p>
                  </p>
                </div>
              </div>
              <div className={`${classes.cardRoot2} ${classes.claimContainer}`}>
                <div className={classes.claimConsumptionContainer}>
                  <ClaimConsumption
                    claimConsumptionCounts={claimConsumptionCounts}
                    showDetailedView={false}
                  />
                </div>
                <div className={classes.claimTrendContainer}>
                  <ClaimTrend
                    claimConsumptionCounts={claimConsumptionCounts}
                    portfolioData={portFolioData}
                    showDetailedView={false}
                  />
                </div>
                <div className={classes.pendingClaimsContainer}>
                  <PendingClaims
                    claimCounts={claimStatusCounts}
                    financialClaimCounts={financialClaimStatusCounts}
                    claimsData={claimsTypeData}
                    financialClaimsData={financialClaimsTypeData}
                    showDetailedView={showPendingClaimsDetailedView()}
                    date={claimStatusUpdatedOn}
                    financialDate={financialClaimStatusUpdatedOn}
                    type={INSURANCE_CATEGORIES?.HEALTH}
                  />
                </div>
              </div>
              <p className={classes.portfolioContainer}>
                <span>PortFolio Analysis</span>
                <span
                  className={`${classes.viewAll} ${classes.riskReportsView}`}
                  onClick={handleDetailedView}
                  id='portpoliaanalysis'
                >
                  {RISK_REPORTS?.VIEW_ALL}
                </span>
              </p>
              <div className={classes.cardRoot1}>
                <div className={classes.portfolioTableView}>
                  {portFolioColumns?.map((item) => {
                    return (
                      <p
                        key={`portfolio_column_${item}`}
                        className={classes.portfolioTableText}
                      >
                        {item}
                      </p>
                    )
                  })}
                </div>
                <div className={classes.portfolioBodyView}>
                  {portFolioData?.map((item, index) => {
                    if (index < 5) {
                      return singleRow(item)
                    } else {
                      return null
                    }
                  })}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
}

export default HealthInsuranceDetails

const useStyles = makeStyles({
  root: {
    background: COLORS.WHITE,
    position: 'relative',
    height: '100%',
  },
  circularProgressPosition: {
    margin: 'auto',
  },
  cardPadding: {
    padding: 0,
  },
  portfolioTableView: {
    display: 'flex',
    fontSize: '13px',
    borderBottom: '1px solid #BBBBBB',
    padding: '5px 0px 0px 0px',
    backgroundColor: '#F2F2F2',
  },
  portfolioBodyView: {
    fontSize: '12px',
    // padding: "5px 0px 0px 0px",
  },
  rowContianer: {
    display: 'flex',
  },
  riskTitle: {
    fontSize: '22px',
    marginTop: 0,
    fontWeight: 600,
  },
  contentDetails: {
    paddingTop: '15px',
    paddingLeft: '10px',
  },
  riskReportsView: {
    cursor: 'pointer',
    float: 'right',
  },
  cardRoot: {
    border: '1px solid #BBBBBB',
    borderRadius: '10px',
    overflow: 'hidden',
    marginBottom: '24px',
  },
  portfolioContainer: {
    width: '65vw',
    textAlign: 'center',
    fontWeight: '600',
    marginBottom: '2px',
  },
  sumInsuredContainer: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '13px',
    borderBottom: '1px solid #D7D7D7',
    padding: '10px 10px',
    backgroundColor: '#F2F2F2',
  },
  pendingClaimsContainer: {
    width: '31%',
    border: '1px solid #BBBBBB',
    borderRadius: '10px',
  },
  cardRoot1: {
    border: '1px solid #BBBBBB',
    borderRadius: '10px',
    overflow: 'hidden',
    marginBottom: '25px',
    width: '65vw',
    marginLeft: '15px',
  },
  permanentEmployeesContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    fontSize: '12px',
    padding: '20px 10px 0px 10px',
  },
  claimContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  claimConsumptionContainer: {
    width: '32%',
    border: '1px solid #BBBBBB',
    borderRadius: '10px',
  },
  claimTrendContainer: {
    width: '31%',
    border: '1px solid #BBBBBB',
    borderRadius: '10px',
  },
  cardRoot2: {
    overflow: 'hidden',
    marginBottom: '17px',
    width: '65vw',
    marginLeft: '15px',
  },
  backBtn: {
    position: 'absolute',
    left: '0px',
    top: '-3px',
  },
  clsBtn: {
    position: 'absolute',
    right: '0px',
  },
  keySuggestionsWrapper: {
    maxHeight: '370px',
    overflow: 'auto',
  },
  sumInsuredTableText: {
    fontWeight: '500',
    color: '#333333',
    margin: '0px 0px 0px 0px',
    paddingLeft: '25px',
  },
  sumInsuredTableColumnText: {
    fontWeight: '500',
    color: '#333333',
    margin: '0px 0px 0px 0px',
    // paddingLeft: "25px",
  },
  premiumPaidTableColumnText: {
    fontWeight: '500',
    color: '#333333',
    margin: '0px 0px 0px 0px',
    paddingLeft: '50px',
  },
  sumInsuredTableText1: {
    fontWeight: '500',
    color: '#333333',
    width: '10vw',
    fontSize: '12px',
    marginBottom: '-1px',
    borderBottom: '0.5px solid #D7D7D7',
    padding: '5px',
  },
  sumInsuredTableText2: {
    fontWeight: '500',
    color: '#333333',
    width: '10vw',
    fontSize: '12px',
    marginBottom: '-1px',
    borderBottom: '0.5px solid #D7D7D7',
    paddingTop: '3px',
  },
  portfolioTableText: {
    fontWeight: '500',
    color: '#333333',
    width: '10vw',
    marginBottom: '5px',
  },
  sumInsuredTableValue: {
    fontWeight: '700',
    color: '#B92250',
    fontSize: '14px',
  },
  familyTableValue: {
    fontWeight: '700',
    color: '#B92250',
    fontSize: '14px',
    width: '15vw',
  },
  viewAll: {
    textDecoration: 'underline',
    fontSize: '13px',
    color: COLORS.LINK_COLOR_LIGHT,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
    },
  },
})
